import React from 'react';
import { Link } from 'react-router-dom';
import { PromotionalBanner as PromotionalBannerType } from '../types';

interface PromotionalBannerProps {
  banner: PromotionalBannerType;
}

const PromotionalBanner: React.FC<PromotionalBannerProps> = ({ banner }) => {
  if (!banner.visible) return null;

  return (
    <section className="relative w-full h-[calc(100vh-6rem)] overflow-hidden group">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={banner.backgroundImage || '/assets/placeholder.svg'}
          alt={banner.title}
          className="w-full h-full object-cover"
        />
        {/* Dark overlay */}
        <div
          className="absolute inset-0 bg-black"
          style={{ opacity: (banner.overlayOpacity ?? 30) / 100 }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between px-6 md:px-12 lg:px-20 py-12 md:py-16 lg:py-20">
        {/* Top: Title + Subtitle */}
        <div>
          <h2 className="font-heading text-5xl md:text-7xl lg:text-[120px] font-bold tracking-tight text-white leading-none">
            {banner.title}
          </h2>
          {banner.subtitle && (
            <p className="font-heading text-lg md:text-xl lg:text-2xl tracking-[0.15em] text-white/80 mt-3 md:mt-4 uppercase">
              {banner.subtitle}
            </p>
          )}
        </div>

        {/* Bottom: Copy text + CTA */}
        <div className="max-w-xl">
          {banner.copyText && (
            <p className="font-body text-sm md:text-base text-white/70 mb-6 leading-relaxed">
              {banner.copyText}
            </p>
          )}
          {banner.ctaText && banner.ctaLink && (
            <Link
              to={banner.ctaLink}
              className="inline-block border border-white px-8 md:px-10 py-3 font-heading tracking-[0.2em] text-xs md:text-sm text-white hover:bg-white hover:text-black transition-all duration-300 uppercase"
            >
              {banner.ctaText}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanner;
